<mat-accordion id="AssessmentDetails" class="assesment-details-acordian">
  <mat-expansion-panel [expanded]="true" class="ia-expansion-panel pl-2 mt-2">
    <mat-expansion-panel-header class="ia-mat-panel">
      <mat-panel-title>
        <span class="text-header inc-f">
          Assessment Details
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row ml-2 my-4">
      <div class="col-lg-4">
        <label class="control-label fw">Assessor</label>
        <mat-chip-grid #assessorList class="assessor_input">
          <mat-chip-row *ngFor="let assessor of assessorDD" [selectable]="selectable" [removable]="removable"
            (removed)="removeAssessor(assessor)">
            {{assessor}}
            <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom"
            #trigautoAssessorTemp3="matAutocompleteTrigger" (keydown)="getFilteredData('Assessor', $event)"
            [attr.disabled]="!isADetailPermission ? 'disabled' : null" #assessorInputTemp3
            [formControl]="searchAssessorCntrl" [matAutocomplete]="assessorAutocomplete"
            [matChipInputFor]="assessorList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addAssessor($event)">
        </mat-chip-grid>
        <mat-autocomplete  #assessorAutocomplete="matAutocomplete" (optionSelected)="selectedAssessorEvent($event)">
          <mat-option *ngFor="let assessor of searchedAssessor" [value]="assessor.value">
            {{assessor.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Assessment Status</label>
        <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
          [(ngModel)]="impactAssessment.assessmentStatus">
          <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
        </select>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="box-shadow p-2">
          <div class="header-text">
            <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails1" (click)="isIADetails1 = true"></span>
            <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails1" (click)="isIADetails1 = false"></span>
            <span class="control-label fw">
              Publication Proposal - Please provide a summary of what the publication is proposing
            </span>
          </div>
          <div class="text-area-css overflow-auto" *ngIf="publicationDetails">
            <div>
              <div class="pt-3">
                <div class="f-16" [innerHTML]="sanitizeHtml(publicationDetails)"></div>
              </div>
            </div>
          </div>
          <div class="text-area-css overflow-auto disabled-div"
            *ngIf="!isADetailPermission && publicationDetails === ''" [innerHTML]="publicationDetail"></div>
          <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails1" id="assessmentDetails1" class="f-16" [data]="impactAssessment.assessmentDetails1"
            *ngIf="isADetailPermission && isIADetails1"
            (keyUpEvent)="updateSectionLastEditedChild('Assessment')"></app-ck-editor>

          <!-- <ckeditor [editor]="Editor" id="assessmentDetails1" class="f-16" *ngIf="isADetailPermission && isIADetails1"
              [(ngModel)]="impactAssessment.assessmentDetails1" (keyup)="updateSectionLastEditedChild('Assessment')">
            </ckeditor> -->
        </div>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="box-shadow p-2">
          <div class="header-text">
            <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails2" (click)="isIADetails2 = true"></span>
            <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails2" (click)="isIADetails2 = false"></span>
            <span class="control-label fw">
              Impact - Please provide a summary of publication's impact on
              business/operational/processes/policies
            </span>
          </div>
          <div class="text-area-css overflow-auto" *ngIf="impactDetails">
            <div>
              <div class="pt-3">
                <div class="f-16" [innerHTML]="sanitizeHtml(impactDetails)"></div>
              </div>
            </div>
          </div>
          <div class="text-area-css overflow-auto disabled-div" *ngIf="!isADetailPermission && impactDetails === ''"
            [innerHTML]="impactDetails"></div>
          <!-- <ckeditor [editor]="Editor" id="assessmentDetails2" class="f-16" *ngIf="isADetailPermission && isIADetails2"
              [(ngModel)]="impactAssessment.assessmentDetails2" (keyup)="updateSectionLastEditedChild('Assessment')">
            </ckeditor> -->
          <app-ck-editor [(childVariable)]="impactAssessment.assessmentDetails2" id="assessmentDetails2" class="f-16" [data]="impactAssessment.assessmentDetails2"
            *ngIf="isADetailPermission && isIADetails2"
            (keyUpEvent)="updateSectionLastEditedChild('Assessment')"></app-ck-editor>
        </div>
      </div>
    </div>
    <div class="row ml-2 align-items-end mt-1">
      <div class="col-lg-3">
        <label class="control-label fw">Capital/RWA Impact</label>
        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.capitalRWAImpact">
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div class="col-lg-3">
        <label class="control-label fw">
          Impact Rating Lite
          <span class="label ml-2 label-default bg-default p5-20" *ngIf="!impactAssessment.impactRatingLite">None</span>
          <span class="label ml-2 label-default bg-red p5-20"
            *ngIf="impactAssessment.impactRatingLite === 'Very High'">Very
            High</span>
          <span class="label ml-2 label-default bg-orange p5-20"
            *ngIf="impactAssessment.impactRatingLite === 'High'">High</span>
          <span class="label ml-2 label-default bg-yellow p5-20"
            *ngIf="impactAssessment.impactRatingLite === 'Medium'">Medium</span>
          <span class="label ml-2 label-default bg-green p5-20"
            *ngIf="impactAssessment.impactRatingLite === 'Low'">Low</span>
        </label>
        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.impactRatingLite">
          <option value="Low">Low</option>
          <option value="Medium">Medium</option>
          <option value="High">High</option>
          <option value="Very High">Very High</option>
        </select>
      </div>
      <div class="col-lg-3">
        <label class="control-label fw">Lobbying Required ?</label>
        <select class="form-control form-control-sm" [(ngModel)]="impactAssessment.isLobbyingRequired">
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div class="col-lg-3">
        <button class="btn bg-g-lightGreen btn-sm float-right" (click)="addAssessmentDetails()">
          Add Action</button>
      </div>
    </div>
    <div class="row ml-2 mt-1" *ngFor="let item of impactAssessment.assessmentDetailsList;let i=index">
      <div class="col-lg-12">
        <div class="box-shadow p-2" [title]="actionedRequiredText">
          <div class="header-text">
            <span class="fa fa-chevron-down cursor-pointer" *ngIf="!isIADetails3" (click)="isIADetails3 = true"></span>
            <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIADetails3" (click)="isIADetails3 = false"></span>
            <span class="control-label fw">
              Action Required - Identify necessary compliance actions for the regulatory change. Use this field to
              record actions on details to be shared with business areas, gap analysis of proposed requirements, and
              initiating compliance-led projects
            </span>
          </div>
          <div class="text-area-css overflow-auto"
            *ngIf="actionsRequiredArray && item.actionsRequired != '' && item.actionsRequired != undefined && actionsRequiredArray[i] != undefined">
            <div>
              <div class="pt-3" *ngIf="actionsRequiredArray.length > 0">
                <div class="f-16" [innerHTML]="sanitizeHtml(actionsRequiredArray[i])"></div>
              </div>
            </div>
          </div>
          <!-- <div class="text-area-css overflow-auto disabled-div"
              *ngIf="!isADetailPermission && iaDetailHistory && iaDetailHistory.actionRequired.length === 0 && item.actionsRequired != '' && item.actionsRequired != undefined"
              [innerHTML]="impactAssessment.assessmentDetailsList"></div> -->
          <!-- <ckeditor [editor]="Editor" id="actionRequired" class="f-16" *ngIf="isADetailPermission && isIADetails3"
              [(ngModel)]="item.actionsRequired" (keyup)="updateSectionLastEditedChild('Assessment')">
            </ckeditor> -->
          <app-ck-editor [(childVariable)]="item.actionsRequired" id="actionRequired" class="f-16" [data]="item.actionsRequired"
            *ngIf="isADetailPermission && isIADetails3"
            (keyUpEvent)="updateSectionLastEditedChild('Assessment')"></app-ck-editor>
        </div>
      </div>
      <div class="col-lg-3 mt-3">
        <label class="control-label fw">Next Action Date</label>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="assessmentDueDate" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
            (click)="assessmentDueDate.open()" class="form-control form-control-sm border-bottom"
            [(ngModel)]="item.nextActionDate" name="AssessmentDueDate"
            (dateInput)="updateSectionLastEditedChild('Assessment')" />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" *ngIf="isADetailPermission"
              (click)="assessmentDueDate.open()"></span>
            <span class="input-group-text fa fa-calendar" *ngIf="!isADetailPermission"></span>
          </div>
        </div>
        <mat-datepicker #assessmentDueDate (selectedChanged)="updateSectionLastEditedChild('Assessment')">
        </mat-datepicker>
      </div>
      <div class="col-lg-3 mt-3">
        <label class="control-label fw">Action Status</label>
        <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
          (change)="updateSectionLastEditedChild('AssessmentStatus')" [(ngModel)]="item.actionStatus">
          <option *ngFor="let option of assessmentStatus" value="{{option}}">{{option}}</option>
        </select>
      </div>
      <div class="col-lg-5 mt-3">
        <label class="control-label fw">Action Owner</label>
        <mat-chip-grid #actionOwnerList>
          <mat-chip-row *ngFor="let owner of item.actionOwner|stringToArrayParent" [selectable]="selectable"
            [removable]="removable" (removed)="removeMultipleActionOwner(owner,i)">
            {{owner}}
            <mat-icon matChipRemove *ngIf="removable && isADetailPermission" class="clear-icons">clear</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom"
            #trigautoOwner="matAutocompleteTrigger" (keydown)="getFilteredData('ActionOwner', $event)"
            [attr.disabled]="!isADetailPermission ? 'disabled' : null" #ownerInput
            [formControl]="searchActionOwnerCntrl" [matAutocomplete]="actionOwnerAutocomplete"
            [matChipInputFor]="actionOwnerList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addActionOwner($event,item.actionOwner,i)">
        </mat-chip-grid>
        <mat-autocomplete #actionOwnerAutocomplete="matAutocomplete"
          (optionSelected)="selectedMultipleActionOwnerEvent($event,item.actionOwner,i)">
          <mat-option *ngFor="let owner of searchedActionOwner" [value]="owner.value">
            {{owner.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-lg-1 mt-3">
        <span *ngIf="impactAssessment.assessmentDetailsList.length>1" class="cursor-pointer fg-red"
          (click)="removeAssessmentDetails(i)"><span class="fa fa-trash"></span>
          <span class="text-primary ml-1">Delete</span>
        </span>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
<mat-accordion id="ImplementationDetails">
  <mat-expansion-panel class="ia-expansion-panel pl-2 mt-2" [expanded]="true">
    <mat-expansion-panel-header class="ia-mat-panel">
      <mat-panel-title>
        <span class="text-header inc-f">
          Implementation Details
        </span>
        <span *ngIf="filterType !== 'version' && isIDPermission" class="cursor-pointer ml-3" style="font-size:14px">
          <i class="fa fa-square-o icon-font vertical-align-top" (click)="checkImplementationDetailRequired('Checked')"
            *ngIf="!impactAssessment.isImplementationRequired" aria-hidden="true"></i>
          <i class="fa fa-check-square icon-font vertical-align-top"
            (click)="checkImplementationDetailRequired('UnChecked')" *ngIf="impactAssessment.isImplementationRequired"
            aria-hidden="true"></i>
          Not Required
        </span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="row ml-2 mt-1">
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Team</label>
        <input type="text" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
          (keyup)="updateSectionLastEditedChild('ImplementationTeam')" class="form-control form-control-sm"
          [(ngModel)]="impactAssessment.implementationTeam" />
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Owner</label>
        <mat-chip-grid #imptList>
          <mat-chip-row *ngFor="let implmt of imptOwnerDD" [selectable]="selectable" [removable]="removable"
            (removed)="removeImplementationOwner(implmt)">
            {{implmt}}
            <mat-icon matChipRemove *ngIf="removable && isIDetailPermission" class="clear-icons">clear</mat-icon>
          </mat-chip-row>
          <input class="form-control form-control-sm mat-autodd-input border-bottom"
            #trigautoImpOwnerTemp3="matAutocompleteTrigger" (keydown)="getFilteredData('Owner', $event)"
            [attr.disabled]="!isIDetailPermission ? 'disabled' : null" #imptOwnerInputTemp3
            [formControl]="searchImptOwnerCntrl" [matAutocomplete]="imptOwnerAutocomplete" [matChipInputFor]="imptList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
            (matChipInputTokenEnd)="addImplementationOwner($event)">
        </mat-chip-grid>
        <mat-autocomplete #imptOwnerAutocomplete="matAutocomplete"
          (optionSelected)="selectedImplementationOwnerEvent($event)">
          <mat-option *ngFor="let implmt of searchedImptOwner" [value]="implmt.value">
            {{implmt.name}}
          </mat-option>
        </mat-autocomplete>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Type</label>
        <select class="form-control form-control-sm" [attr.disabled]="!isADetailPermission ? 'disabled' : null"
          (change)="updateSectionLastEditedChild('ImplementationType')"
          [(ngModel)]="impactAssessment.implementationType">
          <option *ngFor="let option of implementationType" value="{{option}}">{{option}}</option>
        </select>
      </div>
    </div>
    <div class="row ml-2 mt-1">
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Due Date</label>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="implementationDueDate"
            [attr.disabled]="!isIDetailPermission ? 'disabled' : null" (click)="implementationDueDate.open()"
            class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.implementationDueDate"
            name="ImplementationDueDate" (dateInput)="updateSectionLastEditedChild('Implementation')" />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" *ngIf="isIDetailPermission"
              (click)="implementationDueDate.open()"></span>
            <span class="input-group-text fa fa-calendar" *ngIf="!isIDetailPermission"></span>
          </div>
        </div>
        <mat-datepicker #implementationDueDate></mat-datepicker>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Last Edited</label>
        <div class="input-group input-group-sm">
          <input matInput [matDatepicker]="implementationLastEdited" disabled (click)="implementationLastEdited.open()"
            class="form-control form-control-sm border-bottom" [(ngModel)]="impactAssessment.implementationLastEdited"
            name="ImplementationLastEdited" />
          <div class="input-group-append">
            <span class="input-group-text fa fa-calendar" disabled (click)="implementationLastEdited.open()"></span>
          </div>
        </div>
        <mat-datepicker #implementationLastEdited></mat-datepicker>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Implementation Status</label>
        <select class="form-control form-control-sm" [attr.disabled]="!isIDetailPermission ? 'disabled' : null"
          (change)="updateSectionLastEditedChild('ImplementationStatus')"
          [(ngModel)]="impactAssessment.implementationStatus">
          <option *ngFor="let option of implementationStatus" value="{{option}}">{{option}}</option>
        </select>
      </div>
    </div>

    <div class="row ml-2 mt-1">
      <div class="col-lg-12">
        <div class="box-shadow p-2">
          <div class="header-text py-2">
            <span class="fa fa-chevron-down cursor-pointer" *ngIf="isIDetailPermission && !isIDetails"
              (click)="isIDetails = true"></span>
            <span class="fa fa-chevron-up cursor-pointer" *ngIf="isIDetailPermission && isIDetails"
              (click)="isIDetails = false"></span>
            <span class="control-label fw">
              Implementation Details
            </span>
          </div>
          <div class="text-area-css overflow-auto" *ngIf="implementationDetails">
            <div>
              <div class="pt-3">
                <div class="f-16" [innerHTML]="sanitizeHtml(implementationDetails)"></div>
              </div>
            </div>
          </div>
          <div class="text-area-css overflow-auto disabled-div"
            *ngIf="!isIDetailPermission && implementationDetails === ''" [innerHTML]="implementationDetails"></div>
          <app-ck-editor [(childVariable)]="impactAssessment.implementationDetails" id="implementationDetails" [data]="impactAssessment.implementationDetails"
            class="f-16 pt-1" *ngIf="isIDetails"
            (keyUpEvent)="updateSectionLastEditedChild('Implementation')"></app-ck-editor>
          <!-- <ckeditor [editor]="Editor" id="implementationDetails" class="f-16 pt-1" *ngIf="isIDetails"
              [(ngModel)]="impactAssessment.implementationDetails"
              (keyup)="updateSectionLastEditedChild('Implementation')">
            </ckeditor> -->
        </div>
      </div>
    </div>
    <div class="row ml-2 pt-3">
      <div class="col-lg-8">
        <span class="text-primary ml-1 fw" *ngIf="!isIDetailPermission">Upload Evidence - Review</span>
        <div class="col-lg-5 cursor-pointer" *ngIf="isIDetailPermission" (click)="uploadEvidenceImplementation()">
          <i class="fa fa-upload"></i>
          <span class="text-primary ml-1 fw">Upload Evidence - Implementation
            <i *ngIf="isImplementationLoader" class="fa fa-circle-o-notch fa-spin"
              style="font-size: .875rem; line-height: 1.5;"></i>
          </span>
          <input id="uploadEviImplementation" #myFileInput3 (change)="handleImplementationInput($event.target.files)"
            type="file" multiple style="display: none" /><br />
        </div>
        <div class="col-lg-12 mt-3" *ngIf="impactAssessmentDocument.length > 0">
          <ng-container *ngFor="let docs of impactAssessmentDocument">
            <div class="file-div text-center" *ngIf="docs.fileType === 3">
              <span class="fa fa-trash pull-right delete-docs" *ngIf="isIDetailPermission"
                (click)="openDeleteModel(docs.id, 'Implementation')"></span>
              <span class="cursor-pointer"
                (click)="downloadDocument(docs.id, docs.fileName, docs.fileExtension, 'Implementation')">
                <i class="fa fa-file-text fa-2x" *ngIf="docs.fileExtension === '.txt'" aria-hidden="true"></i>
                <i class="fa fa-file-text-o fa-2x"
                  *ngIf="docs.fileExtension === '.eml' || docs.fileExtension === '.msg'" aria-hidden="true"></i>
                <i class="fa fa-file-pdf-o fa-2x" *ngIf="docs.fileExtension === '.pdf'" aria-hidden="true"></i>
                <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.doc'" aria-hidden="true"></i>
                <i class="fa fa-file-word-o fa-2x" *ngIf="docs.fileExtension === '.docx'" aria-hidden="true"></i>
                <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xls'" aria-hidden="true"></i>
                <i class="fa fa-file-excel-o fa-2x" *ngIf="docs.fileExtension === '.xlsx'" aria-hidden="true"></i>
                <i class="fa fa-file-o fa-2x" *ngIf="docs.fileExtension === '.csv'" aria-hidden="true"></i>
                <i class="fa fa-file-code-o fa-2x" *ngIf="docs.fileExtension === '.xml'" aria-hidden="true"></i>
                <i class="fa fa-file-archive-o fa-2x" *ngIf="docs.fileExtension === '.zip'" aria-hidden="true"></i>
                <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpeg'" aria-hidden="true"></i>
                <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.jpg'" aria-hidden="true"></i>
                <i class="fa fa-file-image-o fa-2x" *ngIf="docs.fileExtension === '.png'" aria-hidden="true"></i>
                <i class="fa fa-file-powerpoint-o fa-2x"
                  *ngIf="docs.fileExtension === '.ppt' || docs.fileExtension === '.pptx'" aria-hidden="true"></i>
              </span>
              <div class="data-div">{{docs.fileName}}</div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="col-lg-4">
        <label class="control-label fw">Project Reference</label>
        <input type="text" class="form-control form-control-sm" [(ngModel)]="impactAssessment.projectReference"
          [matAutocomplete]="auto" (change)="setProjectPreference()">
        <mat-autocomplete #auto="matAutocomplete" class="refernce-autocomplete">
          <mat-option [value]="'Not Applicable'">
            Not Applicable
          </mat-option>
        </mat-autocomplete>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>